module.exports = __webpack_public_path__ + "static/media/1c.80ec639d.jpg";